import { useState, useEffect, useRef } from "react";
import { getCities } from "../../../service/api";
import { getCategories } from "../../../service/api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

function Category() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategories()
      .then((res) => {
        console.log("Categories API response:", res);

        if (Array.isArray(res.data)) {
          setCategories(res.data);
        } else if (Array.isArray(res.data.data)) {
          setCategories(res.data.data);
        } else {
          console.warn("Unexpected response format", res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
      <section className="categories pt-50 pb-50">
        <div className="site-width">
          <div className="titleSection text-center wow animate__fadeInDown">
            <h2>Browse by category</h2>
            <p>2025 jobs live.</p>
          </div>
          {loading ? (
            <p>Loading categories...</p>
          ) : categories.length === 0 ? (
            <p>No categories found</p>
          ) : (
            <Swiper
              spaceBetween={20}
              slidesPerView={4}
              navigation
              autoplay={{ delay: 3000 }}
              modules={[Navigation, Autoplay]}
            >
              {categories.map((category) => (
                <SwiperSlide key={category.id}>
                  <a href={`/job-category/${category.id}`}>
                    <div className="categoryCard wow animate__zoomIn">
                      <div className="categoryHeader">
                        <div className="categoryImg">
                          <img
                            src={
                              category.image ||
                              "/assets/img/icons/human-resource.png"
                            }
                            alt={category.name}
                          />
                        </div>
                        <div className="categoryContent">
                          <h4 style={{ fontSize: "15px" }}>{category.name}</h4>
                          <p style={{ fontSize: "13px" }}>
                            {category.jobCount}{" "}
                            {category.jobCount === 1 ? "Job" : "Jobs"} Available
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          )}

          <div className="seeallbtnwrap text-center mt-4 wow animate__fadeInUp">
            <a href="/job-category" className="outlineBtn">
              See More Categories <i className="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </section>
  );
}

export default Category;
